export class ManipulaMensagemErro {

    static trataMensagem(resposta: JSON) {
        const primeiraChave = Object.keys(resposta)[0];
        const mensagem = resposta[primeiraChave];
        return `${primeiraChave}: ${mensagem}`;
    }
}